// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
export const DEFAULT_GAS_CHANNEL = 'fabric-elements';
